var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.5V21.5M18 15.5V21.5M8 11.5H24M23 11.5L22.133 23.642C22.0971 24.1466 21.8713 24.6188 21.5011 24.9636C21.1309 25.3083 20.6439 25.5 20.138 25.5H11.862C11.3561 25.5 10.8691 25.3083 10.4989 24.9636C10.1287 24.6188 9.90292 24.1466 9.867 23.642L9 11.5H23ZM19 11.5V8.5C19 8.23478 18.8946 7.98043 18.7071 7.79289C18.5196 7.60536 18.2652 7.5 18 7.5H14C13.7348 7.5 13.4804 7.60536 13.2929 7.79289C13.1054 7.98043 13 8.23478 13 8.5V11.5H19Z",
    stroke: "#F8D7DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconGrey);
export default __webpack_public_path__ + "static/media/delete_icon_grey.a8773cb97898f083dddccc9ca6d28db7.svg";
export { ForwardRef as ReactComponent };